import { List, Tabs } from "antd";
import styled from "styled-components";

const TabStyled = styled(Tabs)`
  &.ant-tabs {
    & .ant-tabs-tab {
      padding: 14px 0;
    }
    & .ant-tabs-tab,
    & .ant-tabs-tab > .ant-tabs-tab-btn > .ant-badge {
      font-size: 17px;
      font-weight: 500;
      color: ${({ theme }) => theme.color.gray5};
      &.ant-tabs-tab-active {
        & .ant-tabs-tab-btn,
        .ant-tabs-tab-btn > .ant-badge {
          font-weight: 700;
          color: ${({ theme }) => theme.color.gray2};
        }
      }
    }

    & .ant-tabs-content-holder,
    & .ant-tabs-content-holder > * {
      height: 100%;
    }
  }
`;

/**
 * tab content style
 * -- 헤더 고정이기때문에 높이 고정
 */
const TabContent = styled.div`
  padding: 0;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.color.gray12};
`;

/**
 * 섹션카드 컴포넌트
 */
const Section = styled.section`
  padding: 20px;
  background: ${({ theme }) => theme.color.gray12};
`;

const ListStyled = styled(List)`
  &.ant-list {
    & .ant-list-items {
      & .ant-list-item {
        padding: 0;
        &:not(:last-child) {
          padding-bottom: 12px;
          background-color: ${({ theme }) => theme.color.gray10};
        }
      }
    }
  }
`;

export { ListStyled, Section, TabContent, TabStyled };
